export default __webpack_public_path__ + "0c9f33711faf7ff83bc20aeb41329fec.jpg";